import {Component} from '@angular/core';
import {MatTableModule} from '@angular/material/table';

export interface RSSIRanges {
  modelid: string;
  productname: string;
  minRSSI: number;
  maxRSSI: number;
}

const RSSI_DATA: RSSIRanges[] = [
  {modelid: "iPhone10,1", productname: 'iPhone 8', minRSSI: 36, maxRSSI: 61},
  {modelid: "iPhone10,2", productname: 'iPhone 8 Plus', minRSSI: 36, maxRSSI: 61},
  {modelid: "iPhone10,3", productname: 'iPhone X Global', minRSSI: 36, maxRSSI: 61},
  {modelid: "iPhone10,4", productname: 'iPhone 8', minRSSI: 36, maxRSSI: 61},
  {modelid: "iPhone10,5", productname: 'iPhone 8 Plus', minRSSI: 36, maxRSSI: 61},
  {modelid: "iPhone10,6", productname: 'iPhone X GSM', minRSSI:36, maxRSSI: 61},
  {modelid: "iPhone9,1", productname: 'iPhone 7', minRSSI: 39, maxRSSI: 65},
  {modelid: "iPhone9,2", productname: 'iPhone 7 Plus', minRSSI: 39, maxRSSI: 65},
  {modelid: "iPhone9,3", productname: 'iPhone 7', minRSSI: 39, maxRSSI: 65},
  {modelid: "iPhone9,4", productname: 'iPhone 7 Plus', minRSSI: 39, maxRSSI: 65},

  {modelid: "iPhone8,1", productname: 'iPhone 6s', minRSSI: 39, maxRSSI: 67},
  {modelid: "iPhone8,2", productname: 'iPhone 6s Plus', minRSSI: 39, maxRSSI: 67},
  {modelid: "iPhone8,4", productname: 'iPhone SE (GSM)', minRSSI: 39, maxRSSI: 65},
  {modelid: "iPhone7,1", productname: 'iPhone 6 Plus', minRSSI: 42, maxRSSI: 67},
  {modelid: "iPhone7,2", productname: 'iPhone 6', minRSSI: 42, maxRSSI: 67},
  {modelid: "Galaxy S7", productname: 'Galaxy S7', minRSSI:43, maxRSSI: 74},
  {modelid: "V20", productname: 'V20', minRSSI: 46, maxRSSI: 74},
  {modelid: "NEXUS 6", productname: 'NEXUS 6', minRSSI: 51, maxRSSI: 74},
  {modelid: "LG GOOGLE PIXEL XL2", productname: 'LG GOOGLE PIXEL XL2', minRSSI: 44, maxRSSI: 74},
  {modelid: "PIXEL 2", productname: 'PIXEL 2', minRSSI: 44, maxRSSI: 74},
  {modelid: "GALAXY S5", productname: 'GALAXY S5', minRSSI: 46, maxRSSI: 73},
  {modelid: "UNKOWN", productname: 'UNKOWN', minRSSI: 46, maxRSSI: 71}


];

/**
 * @title Displays RSSI data for each product
 */
@Component({
  selector: 'rssi-table-page',
  styleUrls: ['rssi-table-page.scss','../bleclassmodule/bleclassmodule.css'],
  templateUrl: 'rssi-table-page.html',
})
export class RSSITablePage {
  displayedColumns: string[] = ['modelid', 'productname', 'minRSSI', 'maxRSSI'];
  dataSource = RSSI_DATA;
}
